import { ref, onMounted } from 'vue'

export function useKlaroConsent() {
  const isKlaroReady = ref(false)

  // Sprawdź czy Klaro jest gotowe
  const checkKlaroReady = () => {
    return window.klaro && typeof window.klaro.getManager === 'function'
  }

  // Sprawdź zgodę bezpośrednio z ciasteczka (fallback)
  const getConsentFromCookie = (serviceName) => {
    try {
      const klaroCookie = document.cookie
        .split(';')
        .find(cookie => cookie.trim().startsWith('klaro='))
      
      if (klaroCookie) {
        const consentData = JSON.parse(decodeURIComponent(klaroCookie.split('=')[1]))
        return consentData[serviceName] === true
      }
    } catch (error) {
      // Silent error handling
    }
    return false
  }

  // Sprawdź czy użytkownik wyraził zgodę na konkretny serwis
  const hasConsent = (serviceName) => {
    // Najpierw sprawdź przez Klaro manager
    if (checkKlaroReady()) {
      const manager = window.klaro.getManager()
      if (manager.consents && manager.consents[serviceName] === true) {
        return true
      }
    }
    
    // Fallback - sprawdź bezpośrednio z ciasteczka
    return getConsentFromCookie(serviceName)
  }

  // Sprawdź czy użytkownik wyraził zgodę na Google Analytics
  const hasGoogleAnalyticsConsent = () => {
    return hasConsent('google-analytics')
  }

  // Sprawdź czy użytkownik wyraził zgodę na Meta Pixel
  const hasMetaPixelConsent = () => {
    return hasConsent('meta-pixel')
  }

  // Sprawdź czy użytkownik wyraził zgodę na Microsoft Clarity
  const hasClarityConsent = () => {
    return hasConsent('clarity')
  }



  // Sprawdź czy użytkownik wyraził zgodę na Google Ads
  const hasGoogleAdsConsent = () => {
    return hasConsent('google-ads')
  }

  // Sprawdź czy użytkownik wyraził zgodę na Google Sign-In
  const hasGoogleSignInConsent = () => {
    return hasConsent('google-signin')
  }

  // Sprawdź czy użytkownik wyraził zgodę na Facebook SDK
  const hasFacebookSDKConsent = () => {
    return hasConsent('facebook-sdk')
  }

  // Sprawdź czy użytkownik wyraził zgodę na Microsoft SDK
  const hasMicrosoftSDKConsent = () => {
    return hasConsent('microsoft-sdk')
  }

  // Pokaż modal Klaro
  const showKlaroModal = () => {
    if (checkKlaroReady()) {
      window.klaro.show()
    }
  }

  // Czekaj na gotowość Klaro
  const waitForKlaro = () => {
    return new Promise((resolve) => {
      const check = () => {
        if (checkKlaroReady()) {
          isKlaroReady.value = true
          resolve()
        } else {
          setTimeout(check, 100)
        }
      }
      check()
    })
  }

  onMounted(() => {
    // Sprawdź gotowość Klaro przy montowaniu
    if (checkKlaroReady()) {
      isKlaroReady.value = true
    }
  })

  return {
    isKlaroReady,
    hasConsent,
    hasGoogleAnalyticsConsent,
    hasMetaPixelConsent,
    hasClarityConsent,
    hasGoogleAdsConsent,
    hasGoogleSignInConsent,
    hasFacebookSDKConsent,
    hasMicrosoftSDKConsent,
    showKlaroModal,
    waitForKlaro
  }
} 